<article class="main-info" role="contentinfo">
    <div class="row">
        <div class="col-12 col-md-5 img-column">
            <img src="./assets/img/Ilustracion_banco.png" alt="">
        </div>
        <div class="col-12 col-md-7 px-4">
            <form class="bank-form" [formGroup]="bankForm">
                <fieldset class="group mt-3">
                    <label class="bank-label" for="bank"
                        [class.text-danger]="bankForm.get('bank')?.invalid && bankForm.get('bank')?.touched">*Banco:</label>
                    <div class="group_input-wrapper">
                        <input type="text" id="bank" class="mt-1 form-control estiloPrincipal"
                            placeholder="Escribe y selecciona el banco" formControlName="bank" autocomplete="off" />
                        <img class="icon-search" src="./assets/img/svg/Buscar.svg" alt="search">
                    </div>

                    @if (showError()) {
                    <small class="error">Debes ingresar el banco.</small>
                    }


                    @if(filteredBanks.length > 0){
                    <ul class="dropdown">
                        @for (bank of filteredBanks; track bank['Nit']) {
                        <li class="dropdown-item" role="button" tabindex="0" (click)="selectBank(bank)"
                            (keydown.enter)="selectBank(bank)" (keydown.space)="selectBank(bank)">
                            <p> {{ bank['Banco'] }} </p>
                        </li>
                        }
                    </ul>
                    }



                </fieldset>

                <div class="mt-5">
                    <app-button [text]="'Continuar'" [type]="'primary'" [size]="'small'" [witch]="'fullwidth'"
                        [disabled]="disabled()" (clicked)="handleBankSelected()"></app-button>
                </div>
            </form>
        </div>
    </div>
</article>